import React, { useEffect } from "react";

const AstaCita: React.FC = () => {
  useEffect(() => {
    const elements = document.querySelectorAll(".reveal");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-fadeUp");
          }
        });
      },
      { threshold: 0.15 }
    );

    elements.forEach((el) => observer.observe(el));
  }, []);

  const pilar = [
    "Penguatan pertahanan dan keamanan nasional",
    "Kemandirian pangan, energi, dan air",
    "Hilirisasi dan industrialisasi nasional",
    "Peningkatan kualitas pendidikan dan kesehatan",
    "Pemberantasan kemiskinan dan perlindungan sosial",
    "Reformasi birokrasi dan hukum",
    "Pembangunan desa dan pemerataan ekonomi",
    "Penguatan diplomasi dan peran Indonesia global",
  ];

  return (
    <section className="min-h-screen bg-gradient-to-b from-white to-gray-50 px-2 md:px-6 py-10">
      <div className="max-w-7xl mx-auto">
        {/* HERO */}
        <div className="text-center mb-16 opacity-0 reveal">
          <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900">
            Integritas Program <span className="text-primary">Asta Cita</span>
          </h1>

          <p className="mt-6 text-gray-600 text-lg max-w-full md:max-w-3xl mx-auto leading-relaxed ">
            Program ini menjadikan <strong>Asta Cita</strong> sebagai kerangka utama dalam penyusunan konten dan struktur komunikasi, baik melalui website maupun media sosial.
          </p>
        </div>

        {/* GRID */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {pilar.map((item, index) => (
            <div key={index} className="opacity-0 reveal bg-white p-6 rounded-2xl shadow-md hover:shadow-xl transition duration-300 border-t-4 border-primary hover:-translate-y-1" style={{ transitionDelay: `${index * 100}ms` }}>
              <div className="text-3xl font-bold text-primary mb-3">0{index + 1}</div>

              <p className="text-gray-700 leading-relaxed">{item}</p>
            </div>
          ))}
        </div>

        {/* FOOTER TEXT */}
        {/* <div className="mt-20 text-center opacity-0 reveal">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">Pendekatan Strategis Nasional</h2>

          <p className="text-gray-600 max-w-3xl mx-auto leading-relaxed text-lg">Setiap isu nasional dikaitkan dengan pilar Asta Cita agar masyarakat memahami arah pembangunan secara terstruktur, terarah, dan berkelanjutan.</p>
        </div> */}
      </div>
    </section>
  );
};

export default AstaCita;
